module.exports = __webpack_public_path__ + "media/parallax/separated-leaves-10-30baab40.svg";